@let isMdOrAbove = viewportSelectors.isMdAndUp | select;
@let buttonLabelSize = isMdOrAbove ? 'default' : 'small';

<div class="flex flex-row justify-between items-center gap-2 px-4 md:px-[clamp(4rem,10vw,11.25rem)] py-3">
  <!-- Org Logo (if present) or Name -->
  @if (organizationSelectors.loaded | select) {
    <div class="flex flex-col gap-0 md:gap-1">
      @if (organizationSelectors.hasBanner | select) {
        <img [ngSrc]="organizationSelectors.bannerUrl | select:''" fill priority [alt]="organizationSelectors.name | select"
             class="relative h-[2.25rem] md:h-[3.25rem] w-auto object-contain object-center"/>
      } @else {
        <span class="text-headline-small">{{ organizationSelectors.name | select }}</span>
      }
      <p class="text-body-small md:text-body-medium">All rights reserved &copy;{{ currentYear }}</p>
    </div>
  }

  <!-- In-App Links -->
  <div class="flex flex-col items-start gap-1 shrink-0">
    <mx-text-button label="Catalog" [labelSize]="buttonLabelSize" routeName="CATALOG"/>

    @if (patronSelectors.hasPatron | select) {
      <div class="flex flex-row gap-2 md:gap-7">
        <mx-text-button [label]="isMdOrAbove ? 'My Account' : 'Account'" [labelSize]="buttonLabelSize" routeName="DASHBOARD"/>

        <px-arrow-text-button label="Sign Out" [labelSize]="buttonLabelSize" routeName="LOGOUT" class="self-end"/>
      </div>
    }
  </div>
</div>

<!-- Bottom link bar -->
<div class="flex flex-row relative py-1 px-3 md:py-3 md:px-10 border-t border-outline-variant">
  <div class="flex grow flex-row gap-4 md:gap-5 justify-center">
    <ng-container *ngTemplateOutlet="bottomLink; context: {
                                                              label: 'Privacy Policy',
                                                              href: 'https://www.simplicity-ils.com/privacy-policy',
                                                              showDivider: true
                                                            }"/>
    <ng-container *ngTemplateOutlet="bottomLink; context: {
                                                              label: 'Terms of Use',
                                                              href: 'https://www.simplicity-ils.com/terms-of-service',
                                                              showDivider: true
                                                            }"/>
    <ng-container *ngTemplateOutlet="bottomLink; context: {
                                                              label: 'SMS Notification Terms',
                                                              href: 'https://www.simplicity-ils.com/sms-notification-terms',
                                                              showDivider: false
                                                            }"/>
  </div>

  <!-- "Powered By" link -->
  @let simplicityUrl = 'https://www.simplicity-ils.com/';

  @if (isMdOrAbove) {
    <div class="flex flex-row items-center">
      <p class="text-body-medium">Powered By:</p>
      <mx-text-button label="Simplicity" [href]="simplicityUrl"/>
    </div>
  } @else {
    <a class="px-0 py-[2px]" [href]="simplicityUrl" target="_blank" rel="noopener noreferrer">
      <img class="h-[1.5rem] w-[1.5rem] relative object-contain object-center" ngSrc="/assets/icon-logo-simplicity.svg" priority fill alt="Simplicity"/>
    </a>
  }
</div>

<ng-template #bottomLink let-label="label" let-href="href" let-showDivider="showDivider">
  <mx-text-button [label]="label" [labelSize]="buttonLabelSize" [href]="href"/>

  @if (showDivider) {
    <mat-divider [vertical]="true"/>
  }
</ng-template>
